import { CompanySetting } from "src/app/services/response-models/company-settings-response.model";

export class LoadCompanySettings {
    static readonly type = "[App] Load company settings";

    constructor(public payload: Array<CompanySetting>) {}
}
